// [AI_START::module id="feature-flags/flags/maintenance.ts" purpose="Thin adapter: evaluate the maintenance flag id for the app-shell HOC" links=["withMaintenance", "useEvaluateFeatureFlags"]]
import { useMemo } from "react";
import { findFeatureFlag } from "~@/feature-flags/findFeatureFlag";
import { useEvaluateFeatureFlags } from "~@/feature-flags/useEvaluateFeatureFlags";

export const MAINTENANCE_FLAG_ID = "maintenance";

/** Stable identity for useEvaluateFeatureFlags deps (avoid new array each render). */
export const MAINTENANCE_FLAG_IDS: string[] = [MAINTENANCE_FLAG_ID];

type MaintenanceState = {
  enabled: boolean;
  loading: boolean;
};

// [AI_START::function id="useFeatureFlagsMaintenance" purpose="Map maintenance flag evaluation into enabled/loading for UI gating" links=["useEvaluateFeatureFlags", "withMaintenance"]]
export function useFeatureFlagsMaintenance(): MaintenanceState {
  const { flags, loading } = useEvaluateFeatureFlags(MAINTENANCE_FLAG_IDS);

  return useMemo(() => {
    const maintenance = findFeatureFlag(flags, MAINTENANCE_FLAG_ID);
    return {
      enabled: maintenance.enabled,
      loading,
    };
  }, [flags, loading]);
}
// [AI_END::useFeatureFlagsMaintenance]
// [AI_END::feature-flags/flags/maintenance.ts]
